var exports = {
  "Yr": "x93eb46d8--59b1bb--branding-container",
  "m": "x93eb46d8--59b1bb--branding-avatar",
};

module.exports = exports;
